import { TagColor } from '../types';

// Item background colors states
export const ITEM_ACTIVE_BG_COLOR = 'bg-secondary/30';
export const ITEM_PASSIVE_BG_COLOR = 'bg-secondary/10';
export const ITEM_HOVER_BG_COLOR = 'hover:bg-secondary/5';

// --TAG COLORS--
/** Maps tag colors to their corresponding background color classes */
export const TAG_COLOR_TO_COLOR_CLASSES: Record<TagColor, { bgColor: string; textColor: string }> = {
  [TagColor.RED]: { bgColor: 'bg-tags-red', textColor: 'text-tags-red-content' },
  [TagColor.PINK]: { bgColor: 'bg-tags-pink', textColor: 'text-tags-pink-content' },
  [TagColor.PURPLE]: { bgColor: 'bg-tags-purple', textColor: 'text-tags-purple-content' },
  [TagColor.INDIGO]: { bgColor: 'bg-tags-indigo', textColor: 'text-tags-indigo-content' },
  [TagColor.LIGHT_BLUE]: { bgColor: 'bg-tags-light-blue', textColor: 'text-tags-light-blue-content' },
  [TagColor.TEAL]: { bgColor: 'bg-tags-teal', textColor: 'text-tags-teal-content' },
  [TagColor.LIME]: { bgColor: 'bg-tags-lime', textColor: 'text-tags-lime-content' },
  [TagColor.YELLOW]: { bgColor: 'bg-tags-yellow', textColor: 'text-tags-yellow-content' },
  [TagColor.ORANGE]: { bgColor: 'bg-tags-orange', textColor: 'text-tags-orange-content' },
};
